import { render, staticRenderFns } from "./InvoicingItemsInfo.vue?vue&type=template&id=d3e2d2b8&"
import script from "./InvoicingItemsInfo.vue?vue&type=script&lang=js&"
export * from "./InvoicingItemsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports